import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'dynamicFormat'
})
export class DynamicFormatPipe implements PipeTransform {
    transform(value: any, formatType: string, separator: string = ','): any {
      if (value == null || formatType == null) {
        return value;
      }
  
      switch (formatType) {
        case 'number':
          // 使用內建的 number pipe 來格式化數字
          return new DecimalPipe('en-US').transform(parseFloat(value), '1.0-0', 'en-US').replace(/\./g, separator);
        default:
          return value;
      }
    }
}